import React from 'react'
import selectn      from 'selectn'
import PlayerDetails from './PlayerDetails'

const chunk = (arr, len) => {
  let chunks = []
  let n = arr.length
  let i = 0

  while (i < n) {
    chunks.push(arr.slice(i, i += len))
  }
  return chunks
}

const PlayerSet = ({
  players = []
}) => {
  const playerList = players.map((p, j) => {
    return (
      <li key={j}>
        <PlayerDetails href={p.href || '#'} img={p.img} name={p.name} team={p.team} isMedium = {true}  />
        <dl className="player-stats">
          {
            (p.stats || []).map((s, i) => {
              return (
                <dd key={i}><span className="value">{s.value}</span><span className="label">{s.text || s.abbreviation}</span></dd>
              )
            })
          }
        </dl>
      </li>
    )
  })

  return (
    <ul className="two-col-table split">
      {playerList}
    </ul> 
  )

}

export const PlayersToWatch = ({
  roles = {}
}) => {
  let hasPlayers = false
  const playersToWatch = (
    <div className="sub-module players-to-watch">
      <div className="content">
        {
          Object.keys(roles).map((role, i) => {
            let players = roles[role] && roles[role].players || []
            players = chunk(players, 2) || []
            // if players to watch is yet to be decided show empty place holders.
            if(players.length === 1) {
              const tbdStats = selectn('[0][0].stats' , players) || []
              const tbdPlayerDetails = {
                'name':'TBD',
                'team':selectn('tbdTeam', roles) || '',
                'stats': [
                  {
                    'abbreviation':'M',
                    'text':'MAT',
                    'value':'-'
                  },
                  {
                    'abbreviation':selectn('[1].abbreviation', tbdStats) === 'R' ? 'R' : 'W',
                    'text':selectn('[1].text', tbdStats) === 'RUNS' ? 'RUNS' : 'W',
                    'value':'-'
                  },
                  {
                    'abbreviation':selectn('[2].abbreviation', tbdStats) === 'BTA' ? 'BTA' : 'ER',
                    'text':selectn('[2].text', tbdStats) === 'AVG' ? 'AVG' : 'ECO',
                    'value':'-'
                  },
                  {
                    'abbreviation':selectn('[3].abbreviation', tbdStats) === 'BTSR' ? 'BTSR' : 'BWSR',
                    'text':'SR',
                    'value':'-'
                  }
                ]
              }
              let tbdPlayers = []
              for(let i=0; i<2; i++) {
                tbdPlayers.push(tbdPlayerDetails)
              }
              players.push(tbdPlayers)
            }
            if(players.length) {
              hasPlayers = true
              return (
                <div key={i} className="player-container">
                  <h3>Players To Watch - {role}</h3>
                  {
                    (players).map((p, j) => {
                      return <PlayerSet key={j} players={p} />
                    })
                  }
                </div>  
              )
            }
            return null
          })
        }
      </div>
    </div>
  )
  return Object.keys(roles).length && hasPlayers ? playersToWatch : <div className="sub-module players-to-watch"/>
}

export default {
  PlayersToWatch
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/PlayersToWatch.jsx